import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import HomePage from "@/pages/HomePage";
import LegalPage from "@/pages/LegalPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import ArchivesPage from "@/pages/ArchivesPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <SmoothScroll>
          <div className="App bg-black text-white">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/archives" element={<ArchivesPage />} />
                <Route path="/terms" element={<LegalPage pageKey="terms" />} />
                <Route path="/privacy" element={<LegalPage pageKey="privacy" />} />
                <Route path="/disclaimer" element={<LegalPage pageKey="disclaimer" />} />
                <Route path="/cookies" element={<LegalPage pageKey="cookies" />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="*" element={<HomePage />} />
              </Routes>
            </BrowserRouter>
            <Toaster
              position="bottom-right"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#0a0a0a",
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: 0,
                  fontFamily: "Manrope, sans-serif",
                },
              }}
            />
          </div>
        </SmoothScroll>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
